import React from 'react'
import cn from 'classnames'

import styles from './card.scss'

interface IProps {
  children: React.ReactNode | React.ReactNode[]
  className?: string
  style?: React.CSSProperties
}

class Card extends React.Component<IProps> {
  render() {
    const { children, className, style, ...others } = this.props
    return (
      <div
        className={cn(styles.container, className)}
        style={style}
        {...others}
      >
        {children}
      </div>
    )
  }
}

export default Card
